/**
 * Operation utilities, used by classes extending {@link tmrOperationController}
 *
 * @type {ngService}
 */
export class TmrOperationHelper {
  static ngType = 'service'

  constructor(
    tmrDefaultOperationsConfig,
    TmrLocalStorage,
    TmrInvalidConfigurationError
  ) {
    'ngInject'
    Object.assign(this, {
      tmrDefaultOperationsConfig,
      TmrLocalStorage,
      TmrInvalidConfigurationError,
    })
  }

  /**
   * Checks if a config key has a default value; if not, throws error.
   *
   * @param {string} config A key from {@link tmrDefaultOperationsConfig}
   */
  configExists(config) {
    if (this.tmrDefaultOperationsConfig[config] === undefined)
      throw new this.TmrInvalidConfigurationError(
        `Missing default Operation configuration "${config}"`
      )
  }

  /**
   * Retrieves a default configuration parameter for the Operation.
   *
   * Default configuration parameters are defined in {@link tmrDefaultOperationsConfig}.
   * The actual default value may be overridden locally if it's saved in local storage.
   *
   * @param {string} config A key from {@link tmrDefaultOperationsConfig}
   */
  getConfig(config) {
    this.configExists(config)
    return this.TmrLocalStorage.get(
      config,
      this.tmrDefaultOperationsConfig[config]
    )
  }

  /**
   * Overrides a default configuration parameter for the Operation saving it in localStorage
   *
   * @param {string} config A key from {@link tmrDefaultOperationsConfig}
   * @param {*} value The new default value for the configuration
   */
  setConfig(config, value) {
    this.configExists(config)
    this.TmrLocalStorage.set(config, value)
  }
}
